export const isCancelled = (regularPayment: any): boolean => {
    if (regularPayment) {
        var rp = regularPayment.planned ?? regularPayment.current;
        return rp.status === "Cancelled"
    }

    return false;
}
